import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";

const { siteMetadata: config } = GatsbyConfig;

export default class Privacy extends React.Component {
  render() {
    return (
      <div className="policy">
        <h1>Privacy Policy</h1>
        <hr />
        <h3>Commitment To Privacy</h3>
        <p>
          Your privacy is important to us. To better protect your privacy, we
          provide this notice explaining our online information practices and
          the choices you can make about the way your information is collected
          and used. To make this notice easy to find, we make it available on
          our homepage and at every point where personally identifiable
          information may be requested.
        </p>
        <h3>Information We Collect</h3>
        <p>
          This notice applies to all information collected or submitted on the
          Everlasting Tours website. On some pages, you can order products, make
          requests, and register to receive materials. The types of personal
          information collected at these pages are:
        </p>
        <ul>
          <li>Name</li>
          <li>Address</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Credit/Debit Card Information Etc.</li>
        </ul>
        <h3>How We Use Information</h3>
        <p>
          We use the information you provide about yourself when placing an
          order only to complete that order. We do not share this information
          with outside parties except to the extent necessary to complete that
          order.
        </p>
        <p>
          We use return email addresses to answer the email we receive. Such
          addresses are not used for any other purpose and are not shared with
          outside parties.
        </p>
        <p>
          We use non-identifying and aggregate information to better design our
          website and to share with advertisers. For example, we may tell an
          advertiser that X number of individuals visited a certain area on our
          website, or that Y number of men and Z number of women filled out our
          registration form, but we would not disclose anything that could be
          used to identify those individuals.
        </p>
        <p>
          Finally, we never use or share the personally identifiable information
          provided to us online in ways unrelated to the ones described above
          without also providing you an opportunity to opt-out or otherwise
          prohibit such unrelated uses.
        </p>
        <h3>Commitment To Data Security</h3>
        <p>
          To prevent unauthorized access, maintain data accuracy, and ensure the
          correct use of information, we have put in place appropriate physical,
          electronic, and managerial procedures to safeguard and secure the
          information we collect online.
        </p>
        <h3>How You Can Access Or Correct Your Information</h3>
        <p>
          You can access all your personally identifiable information that we
          collect online and maintain by contacting Everlasting Tours via email
          or phone. We use this procedure to better safeguard your information.
        </p>
        <p>
          You can correct factual errors in your personally identifiable
          information by sending us a request that credibly shows error.
        </p>
        <p>
          To protect your privacy and security, we will also take reasonable
          steps to verify your identity before granting access or making
          corrections.
        </p>
        <h3>Cookies: Adroll</h3>
        <p>
          We use the AdRoll website, which uses cookies, tracking pixels and
          related technologies. Cookies are small data files that are served by
          our platform and stored on your device. Our site uses cookies dropped
          by us or third parties for a variety of purposes including to operate
          and personalize the website. Also, cookies may also be used to track
          how you use the site to target ads to you on other websites. To opt
          out, please visit: www.aboutads.info
        </p>
        <h3>How To Contact Us</h3>
        <p>
          Should you have other questions or concerns about these privacy
          policies, please
          {config.showPhone ? ` call us at ${config.phone} or ` : " "}
          send us an email.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/privacy.js